import clsx, { type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combine clsx with tailwind-merge so conflicting Tailwind utilities
 * resolve to the last one (e.g. `cn("p-4", "p-2")` returns `"p-2"`).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
